module.exports = __webpack_public_path__ + "img/geli.347b9958.png";